var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.722 16.296l-4.42-4.42a7.36 7.36 0 0 0-.666-9.703A7.345 7.345 0 0 0 7.4 0a7.345 7.345 0 0 0-5.234 2.173 7.407 7.407 0 0 0 0 10.469A7.345 7.345 0 0 0 7.4 14.815c1.58 0 3.16-.494 4.47-1.506l4.444 4.395a.99.99 0 0 0 .716.296c.247 0 .518-.099.716-.296.37-.37.37-1.013-.025-1.408zM7.426 12.815c-1.457 0-2.79-.568-3.827-1.58-2.099-2.1-2.099-5.531 0-7.655A5.377 5.377 0 0 1 7.426 2c1.457 0 2.79.568 3.827 1.58 1.037 1.013 1.58 2.37 1.58 3.827 0 1.457-.568 2.79-1.58 3.828-1.012 1.037-2.395 1.58-3.827 1.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifier);
export default __webpack_public_path__ + "static/media/icon-magnifier.627fc091c8e9259bcc345d15634d30b5.svg";
export { ForwardRef as ReactComponent };